var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row px-2"},[_c('div',{staticClass:"col-12 rounded",style:(`background: ${_vm.backgroundColor}; border: ${_vm.border}`)},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }